import React, {useState, useEffect} from 'react'
import { Image, Container } from 'react-bootstrap'
import b10 from "../../../../assets/notarymeet/b10.png"
import b1010 from "../../../../assets/notarymeet/b1010.png"

import '../notarymeet.css'


function B10() {

   const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 768);
  
    useEffect(() => {
      const handleResize = () => {
        setIsSmallScreen(window.innerWidth <= 768);
      };
  
      window.addEventListener('resize', handleResize);
  
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);

    const handleContextMenu = (e) => {
      e.preventDefault(); // Disable right-click
    };


  return (
    <Container 
    fluid 
    className='container-section' 
    style={{
      backgroundColor:"#343434",
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: isSmallScreen ? 'auto' : '100vh'
      }}>
        {isSmallScreen ? (
          <Image src={b1010} alt='b1010' width={100+"%"} draggable="false" onContextMenu={handleContextMenu}  height="auto" />
        ) : (
          <Image src={b10} alt='b10' width={100+"%"} draggable="false" onContextMenu={handleContextMenu}  height="auto" />
        )}
       
    </Container>
    
     
    
  )
}

export default B10
